import { render } from "./pageBot.vue?vue&type=template&id=a58b6c8c&scoped=true"
import script from "./pageBot.vue?vue&type=script&lang=js"
export * from "./pageBot.vue?vue&type=script&lang=js"

import "./pageBot.vue?vue&type=style&index=0&id=a58b6c8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a58b6c8c"

export default script